<!-- template for the modal component -->
<template>
  <transition name="modal">
    <div class="modal-mask" @click="hideModal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    },
    messageTime: {
      type: Number,
      required: true
    }
  },
  mounted () {
    setTimeout(() => this.hideModal(), this.messageTime)
  },
  methods: {
    hideModal () {
      this.$emit('hide-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 350px;
    margin: 0px auto;
    padding: 20px 24px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }

  .modal-body {
    margin: 20px 0;
    font-size: 17px;
    text-align: center;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

</style>
